export const toLocaleString = (val: number) => val?.toLocaleString().split(' ').join('.') ?? ''